// @ts-nocheck
import type { CompiledRuntimeNode } from '../compiler';
import type { PressHandlerInput } from '../../types/eventHandler';
import { collectChangeHandlers } from './componentGestureHandlers';

export function componentInteractionProps(node: CompiledRuntimeNode): {
  longPressHandler: PressHandlerInput | null;
  changeHandler: PressHandlerInput | null;
  changeHandlers: PressHandlerInput[];
  loadHandler: PressHandlerInput | null;
} {
  const changeHandlers = collectChangeHandlers(node);
  return {
    longPressHandler: node.interactions?.onLongPress ?? null,
    changeHandler: changeHandlers[0] ?? null,
    changeHandlers,
    loadHandler: node.interactions?.onLoad ?? null,
  };
}
